(function () {
  function bootSizeGuide() {
    var overlay = document.getElementById("zt-size-guide-overlay");
    if (!overlay) return;

    var lastFocus = null;

    function openGuide() {
      lastFocus = document.activeElement;
      overlay.hidden = false;
      document.body.classList.add("zt-size-guide-open");
      var closeBtn = overlay.querySelector("[data-close-size-guide]");
      window.setTimeout(function () {
        if (closeBtn) closeBtn.focus();
      }, 0);
    }

    function closeGuide() {
      overlay.hidden = true;
      document.body.classList.remove("zt-size-guide-open");
      if (lastFocus && typeof lastFocus.focus === "function") {
        lastFocus.focus();
      }
    }

    document.querySelectorAll("[data-open-size-guide]").forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        openGuide();
      });
    });

    document.querySelectorAll("[data-close-size-guide]").forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        closeGuide();
      });
    });

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) closeGuide();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !overlay.hidden) {
        e.preventDefault();
        closeGuide();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootSizeGuide);
  } else {
    bootSizeGuide();
  }
})();
